import {styled, getFont} from "@core-ui/react-stitch";
import {MEDIUM} from "@core-ui/breakpoint-provider";
import {InternalModalProps} from "../types";

type ContentProps = Pick<
  InternalModalProps,
  "crossBrand" | "minWidth" | "negatePadding"
>;

const Content = styled.div<ContentProps>`
  ${getFont("primary")}
  width: 100%;
  box-sizing: border-box;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  height: ${({minWidth}) => (minWidth(MEDIUM) ? "auto" : "100%")}};
  align-content: flex-end;
  iframe {
    width: 100%;
    border: none;
    min-height: 200px;
  }
  ${({negatePadding}) => negatePadding && "padding: 0 0 8em 0;"}
`;

export default Content;
